import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import location_icon from "./../../assets/location-icon.svg";
import price_icon from "./../../assets/price-icon.svg";
import date_icon from "./../../assets/date-icon.svg";
import building_icon from "./../../assets/building-icon.svg"; 
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function HomeConstruction() {
  const swiperRef = useRef(null);

  const [HomeConstruction, setHomeConstruction] = useState({});
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchHomeConstruction = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/home/construction-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomeConstruction(data);
        if (data.slides_content) {
          try {
            const parsedSlides = JSON.parse(data.slides_content);
            setSlides(parsedSlides);
          } catch (error) {
            console.error("Error parsing slides_content:", error);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchHomeConstruction();
  }, []);

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  return (
    <div className="home-construction-sec">
      <Container fluid className="padding-zero">
        <Row className="contruction-swiper-row">
          <Col md={4} className="contruction-content-col">
            <div className="contruction-content-div">
              <h2 className="common-head goldenColor" data-aos="fade-right">
                {HomeConstruction.section_title}
              </h2>
              <p className="common-para" data-aos="fade-right">
                {HomeConstruction.section_description}
              </p>
            </div>
            <button onClick={handlePrev} className="swiper-button-prev">
              {" "}
            </button>
            <button onClick={handleNext} className="swiper-button-next">
              {" "}
            </button>
          </Col>
          <Col
            md={8}
            className="construction-swiper-col padding-zero"
            data-aos="fade-left"
          >
            <div className="construction-swiper-div">
              <Swiper
                modules={[Navigation]}
                ref={swiperRef}
                // navigation={true}
                spaceBetween={40}
                slidesPerView={1.75}
                speed={1000}
                grabCursor={true}
                draggable={true}
                loop={true}
                breakpoints={{
                  200: {
                    slidesPerView: 1,
                  },
                  320: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 1.75,
                    spaceBetween: 40,
                  },
                  992: {
                    slidesPerView: 1.75,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 1.75,
                    spaceBetween: 40,
                  },
                  1280: {
                    slidesPerView: 1.75,
                    spaceBetween: 40,
                  },
                  1920: {
                    slidesPerView: 1.75,
                    spaceBetween: 40,
                  },
                  3840: {
                    slidesPerView: 1.75,
                    spaceBetween: 40,
                  },
                }}
              >
                {slides.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <div className="main-card-layout">
                      <div className="main-card-layout-img">
                        <img
                          src={`${apiUrl.apiUrl}/${slide.image}`}
                          className="img-fluid"
                          alt="Property development in Dubai"
                        />
                      </div>
                      <div className="main-card-layout-container-title-details">
                        <h3 className="main-card-layout-title">
                          {slide.title}
                        </h3>
                        <div className="main-card-layout-details-about">
                          <div className="card-location-main">
                            <div className="card-location-main-icon">
                              <img
                                src={location_icon}
                                className="img-fluid"
                                alt="Luxury Dubai property for sale"
                              />
                            </div>
                            <p className="card-main-text">{slide.place}</p>
                          </div>
                          <div className="card-bedroom-main">
                            <div className="card-bedroom-main-icon">
                              <img
                                src={price_icon}
                                className="img-fluid"
                                alt="Premium Real Estate Dubai"
                              />
                            </div>
                            <p className="card-main-text">{slide.price}</p>
                          </div>
                          <div className="card-location-main">
                            <div className="card-location-main-icon">
                              <img
                                src={date_icon}
                                className="img-fluid"
                                alt="Top real estate developers in Dubai"
                              />
                            </div>
                            <p className="card-main-text">{slide.year}</p>
                          </div>
                          <div className="card-bedroom-main">
                            <div className="card-bedroom-main-icon">
                              <img
                                src={building_icon}
                                className="img-fluid"
                                alt="Best property developers in Dubai"
                              />
                            </div>
                            <p className="card-main-text green-highlight-color">
                              {slide.status}
                            </p>
                          </div>
                        </div>
                        <Link to={slide.button_link} className="marquis-grey-button">{slide.button_text}</Link>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HomeConstruction;
